import { getTravelKitUrl } from '../../../utils/travelKitUrl';
import { TRAVEL_KIT_LANG_BY_LOCALE } from '../../../utils/travelKitLocale';
import { buildTravelKitToken } from '../../ExportOptions/TravelKitLinkConstructor/tokenHelper';

// E-card theme colour (THEME_COLOR_CHOICES) -> the closest travel kit theme preset.
const THEME_BY_COLOR: Record<string, string> = {
  blue: 'bl',
  orange: 'or',
  violet: 'pr',
  green: 'gr',
  earth: 'or'
};

interface ProfilePlusTravelKitParams {
  adviserId?: string;
  locale?: string;
  themeColor?: string;
}

// Same versioned token as the SOS paper link. A public e-card does not know who is reading
// it, so no client name rides along; country and insurer are left to the page's defaults.
export function buildProfilePlusTravelKitHref({ adviserId, locale, themeColor }: ProfilePlusTravelKitParams): string {
  const token = buildTravelKitToken({
    adviserId,
    lang: locale ? TRAVEL_KIT_LANG_BY_LOCALE[locale] : undefined,
    theme: themeColor ? THEME_BY_COLOR[themeColor] : undefined
  });
  return `${getTravelKitUrl()}/?p=${token}`;
}
